let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("39wLT")).then(() => parcelRequire('1rjw0'));